import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  NumberInput,
  NumberInputField,
} from "@chakra-ui/react";

import { IFormField } from "./fieldTypes";

/**
 * JsonForm Number Field component.
 * @param props see {@link IFormField}
 */
function IntegerField({
  field,
  isRequired,
  register,
  disabled = false,
  errorMessage = "",
}: IFormField) {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errorMessage}>
      <FormLabel>{field.label}</FormLabel>
      <NumberInput>
        <NumberInputField
          {...register(field.fieldName, field.config)}
          pattern="(-)?[0-9]?"
          placeholder={field.placeholder}
          disabled={disabled}
        />
      </NumberInput>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
      {!errorMessage && field.helperText && (
        <FormHelperText>{field.helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export { IntegerField };
